import { SCHEDULE_FORMATTED_MAP } from "../../constants/sports";
import { utcToZonedTime, format } from "date-fns-tz";
import { TIME_FORMAT } from "./constants";
import { toZonedTime } from "./utils";
import { getUserTimeZone } from "../dateTime/library";

export const createCaption = (filter, filterBar = {}) => {
    const eventType = filterBar.eventType;
    const main = SCHEDULE_FORMATTED_MAP[eventType] || "";
    let platform =
        (filter?.platform === "web" && "Streaming Schedule") ||
        (filter?.platform === "tv" && "TV Schedule") ||
        "";
    const { isMedal, isTeamCanada, type } = filterBar;
    const filtered = [
        [isMedal, "Medals"],
        [isTeamCanada, "Team Canada"],
        [type, SCHEDULE_FORMATTED_MAP[type]],
    ]
        .map(([key, val]) => (key && val) || "")
        .filter((it) => !!it)
        .join(", ");
    if (filtered && platform) {
        platform = `${platform}, filtered by: ${filtered}`;
    }
    if (main && platform) {
        return `${main} ${platform}`;
    }
    return platform;
};

const statusFormat = (zone, obj) => {
    const { currentDateTime, startDateTime, endDateTime } = toZonedTime(
        obj,
        zone
    );
    if (currentDateTime < startDateTime) {
        return currentDateTime.setHours(0, 0, 0, 0) ===
            startDateTime.setHours(0, 0, 0, 0)
            ? "Today"
            : format(startDateTime, "EEE LLL dd");
    }
    if (currentDateTime >= startDateTime && currentDateTime <= endDateTime) {
        return "On now";
    }

    return "";
};

export const formatRow = (zone) => (item) => {
    const { ti, url, nb, stt, uuid } = item;
    let { startTime, status, title } = item; //old schema
    startTime =
        startTime || format(utcToZonedTime(new Date(stt), zone), TIME_FORMAT);
    status = status || statusFormat(zone, item);
    title = title || ti;
    return {
        status,
        url,
        title,
        startTime,
        nb,
        uuid,
    };
};

export const formatScheduleItem = (currentScheduleItem) => {
    const {
        stt: startTime,
        end: endTime,
        ti: title,
        url,
        uuid,
        nb,
    } = currentScheduleItem;
    if (!startTime || !endTime) return;

    const userTimeZone = getUserTimeZone();
    const currentDate = new Date();
    const currentUserDateTime = utcToZonedTime(currentDate, userTimeZone);
    const scheduleStartDateTime = utcToZonedTime(
        new Date(startTime),
        userTimeZone
    );
    const scheduleEndDateTime = utcToZonedTime(new Date(endTime), userTimeZone);

    const formattedSchedule = {};
    if (currentUserDateTime < scheduleStartDateTime) {
        formattedSchedule.status =
            new Date(currentUserDateTime).setHours(0, 0, 0, 0) ===
            new Date(scheduleStartDateTime).setHours(0, 0, 0, 0)
                ? "Today"
                : format(scheduleStartDateTime, "EEE LLL dd");
    } else if (
        currentUserDateTime >= scheduleStartDateTime &&
        currentUserDateTime <= scheduleEndDateTime
    )
        formattedSchedule.status = "On now";
    else return;
    formattedSchedule.startTime = format(scheduleStartDateTime, TIME_FORMAT);
    formattedSchedule.title = title;
    formattedSchedule.url = url;
    formattedSchedule.uuid = uuid;
    formattedSchedule.nb = nb;
    return formattedSchedule;
};
